export enum ConsumerIdentityParam {
  END_USER_ID = 'endUserId',
  MSISDN = 'phoneNumber',
  ICCID = 'iccid',
  IMSI = 'imsi',
  LINE_ID = 'lineId',
  CURP = 'curp',
  EMAIL = 'email',
}
